import { Switch } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { ChangeEvent } from 'react';
import { SpeakerEntry, SpeakersComponentInterface } from '../../../../../interfaces/pagebuilder';
import { fetchAndSetEventSpeakers } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../../reduxToolkit/typedRedux';
import { createSpeaker } from '../../../../../services/services';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';
import SpeakerCreateButton from './SpeakerSettings/SpeakerCreateButton';
import SpeakersList from './SpeakerSettings/SpeakersList';

interface SpeakersSettingsTableInterface {
  component: SpeakersComponentInterface;
  onChange: (c: SpeakersComponentInterface) => void;
}

const SpeakersSettingsTable = ({ component, onChange }: SpeakersSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);
  const event = useSelector((state) => state.common.event);
  const dispatch = useDispatch();

  async function handleCreateSpeaker(props: SpeakerEntry) {
    if (!event) return;
    delete props._id;
    const speaker = await createSpeaker(event?._id, props);
    const newComponent = { ...component };
    newComponent.entryIds = [...newComponent.entryIds, speaker];
    dispatch(fetchAndSetEventSpeakers(event._id));
    onChange(newComponent);
  }

  function onChangeEntries(entryIds: SpeakerEntry[]) {
    onChange({ ...component, entryIds });
  }

  function changeOrderAlphabetically(e: ChangeEvent<HTMLInputElement>) {
    onChange({ ...component, sortBy: e.target.checked ? 'ALPHABETIC' : 'none' });
  }

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          content: (
            <div className="flex items-center justify-between">
              <p>{t('pagebuilder:sort-alphabet')}</p>
              <Switch defaultChecked={component.sortBy === 'ALPHABETIC'} onChange={changeOrderAlphabetically} />
            </div>
          ),
        },
        {
          content: <SpeakerCreateButton handleCreateSpeaker={handleCreateSpeaker} />,
        },
        {
          content: <SpeakersList component={component} onChange={onChangeEntries} />,
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default SpeakersSettingsTable;
